(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileContentDialogController', FileContentDialogController);

    FileContentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'FileContent'];

    function FileContentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, FileContent) {
        var vm = this;

        vm.fileContent = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fileContent.id !== null) {
                FileContent.update(vm.fileContent, onSaveSuccess, onSaveError);
            } else {
                FileContent.save(vm.fileContent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:fileContentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setContent = function ($file, fileContent) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        fileContent.content = base64Data;
                        fileContent.contentContentType = $file.type;
                    });
                });
            }
        };

    }
})();
